import { Component, Input, OnInit } from '@angular/core';
import { Artifact } from 'src/app/core/models/artifact.model';
import { CertWizService } from 'src/app/core/services/cert-wiz.service';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { ARTIFACTS_ACCEPTANCE } from 'src/app/core/constants/artifacts-order.constants';
import { UiStoreService } from 'src/app/core/services/ui-store.service';
import { ARTIFACT_STATUS } from 'src/app/core/enums/artifact.enum';
import { UserService } from 'src/app/core/services/user.service';
import { USER_ROLES, ROLE_DISPLAY_NAMES } from 'src/app/core/enums/user.enum';

@Component({
  selector: 'app-cert-wiz-controller',
  templateUrl: './cert-wiz-controller.component.html',
  styleUrls: ['./cert-wiz-controller.component.scss'],
})
export class CertWizControllerComponent implements OnInit {
  @Input() isApp = false;
  @Input() addWizObj: any;
  @Input() isDialog = false;
  public percentComplete = 0;

  constructor(
    public _ui: UiStoreService,
    private certWizService : CertWizService,
    private appWizService : AppWizService,
    public userService : UserService,
    
  ) { }

  ngOnInit(): void {
    if(!this.isDialog){
      this._ui.expandedArtifactId.next("");
    }
    this.appWizService.appUpdated$.subscribe(app => {
        if(app && app.artifacts){
            let done = 0;
            app.artifacts.forEach((art: any) => {
                if(art.artifactStatus > ARTIFACT_STATUS.OUTSTANDING){
                    done++;
                    this.percentComplete = (done / this.appWizService.appWizard.artifacts.length) * 100;
                }
            });
            
        }
    })
  }

  artifactsByRole(isApplicant:boolean){
    return this.artifacts()
    .filter(i=>isApplicant ? i.role == 'Applicant': i.role !== 'Applicant')
    .filter(i=>!ARTIFACTS_ACCEPTANCE.includes(i.key));
  }

  agentRoleGroups(): {role: string, label: string, artifacts: Artifact[]}[] {
    const nonApplicant = this.artifacts()
      .filter(i => i.role !== 'Applicant')
      .filter(i => !ARTIFACTS_ACCEPTANCE.includes(i.key));
    const roleMap = new Map<string, Artifact[]>();
    nonApplicant.forEach(a => {
      const list = roleMap.get(a.role) || [];
      list.push(a);
      roleMap.set(a.role, list);
    });
    return Array.from(roleMap.entries()).map(([role, artifacts]) => ({
      role,
      label: ROLE_DISPLAY_NAMES[role] || role + ' Responsibility',
      artifacts
    }));
  }

  isAnyArtifactPending(){
    const isApplicant:boolean = this.userService.getSelectedSiteRole()?.RoleName?.toUpperCase() == USER_ROLES.APPLICANT;
    return this.artifactsByRole(isApplicant).some(i=>{
      return ![ARTIFACT_STATUS.PACKAGECOMPLETE,ARTIFACT_STATUS.COMPLETE].includes(i.artifactStatus);
    });
  }
  isAcceptanceArtifactPending(){
    let acceptanceArtifact = this.getAcceptanceArtifact();
    return !(acceptanceArtifact && [ARTIFACT_STATUS.PACKAGECOMPLETE,ARTIFACT_STATUS.COMPLETE].includes(acceptanceArtifact?.artifactStatus || ARTIFACT_STATUS.COMPLETE));
  }
  isAcceptanceArtifactSelected(){
    return ARTIFACTS_ACCEPTANCE.includes(this.getSelectedArtifact()?.key || "");
  }

  getSelectedArtifact(){
    return this.artifacts().find(i=>i.artifactId == this._ui.expandedArtifactId.value);
  }

  artifacts(): Artifact[]{
    if(this.isApp){
      return this.appWizService.appWizard.artifacts;
    }else{
      return this.certWizService.certWizard.requiredArtifacts;
    }
  }

  agentResponsibilityText(){
    if(this.isApp){
      return this.appWizService.appWizard.agentResponsibilityText;
    }else{
      return this.certWizService.certWizard.agentResponsibilityText;
    }
  }

  selectAcceptanceArtifacts(){
    let acceptanceArtifact = this.getAcceptanceArtifact();
    if(acceptanceArtifact?.artifactId){
      this._ui.expandedArtifactId.next(acceptanceArtifact.artifactId);
    }
  }
  getAcceptanceArtifact(){
    let isEduAgent = this.userService.isEduAgent();
    return this.artifacts()
    .filter(i=>isEduAgent ? i.role !== 'Applicant': i.role == 'Applicant')
    .find(i=>ARTIFACTS_ACCEPTANCE.includes(i.key));
  }
  
  schoolSystemResponsibilityStart(){
    return this.artifacts().findIndex(i=>{
      return i.role !== 'Applicant'
    });
  }
}
